/* Savings Jar rewards page (gt-rewards section). 1 Appstle point = 1 cent in the jar, shown only as dollars.
   Jar money comes off the products in an order (after any other deal), never shipping, for up to half of any order of
   $20 or more (cfg.share / cfg.minCents); the one-customer code the rewards app creates enforces that at checkout.
   Modes: signed in (real Appstle balance), preview (?nest_demo=<cents>, an example member) and signed out (sign-in
   card). Referrals run in Appstle's own program (the member's link is in the referral card). Spending is a preview
   until the section's redeem_live is on. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var cfgEl = root.querySelector('[data-gtr-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var $ = function (sel) { return root.querySelector(sel); };
    var $m = function (c) { return money(c, cfg.money); };
    var pts = function (n) { return Math.floor(n).toLocaleString('en-US'); };
    var $w = function (c) { return Math.round(c) % 100 === 0 ? $m(c).replace(/[.,]00(?=\D*$)/, '') : $m(c); };   // $50, not $50.00
    var params = new URLSearchParams(window.location.search);
    var demo = !cfg.loggedIn && params.has('nest_demo');
    var browse = !cfg.loggedIn && !demo;
    var share = Number(cfg.share) > 0 && Number(cfg.share) <= 1 ? Number(cfg.share) : 0.5;
    var minCents = Number(cfg.minCents) > 0 ? Number(cfg.minCents) : 2000;
    var shopRoot = cfg.root || '/';
    if (shopRoot.slice(-1) !== '/') shopRoot += '/';
    var proxy = String(cfg.proxy || '').replace(/\/$/, '');
    var live = !!(cfg.live && proxy && cfg.loggedIn);

    // Signed in: Appstle's own copy of the balance (set by its app embed) wins if it's newer than the page render.
    var jar = cfg.points;   // cents
    var al = window._ALConfig && window._ALConfig.customerLoyalty;
    if (cfg.loggedIn && al && typeof al.availablePoints === 'number') jar = Math.floor(al.availablePoints);
    var earned = cfg.earned;   // lifetime points earned (Appstle's level count)
    if (demo) {
      var demoJar = parseInt(params.get('nest_demo'), 10);
      var demoEarned = parseFloat(params.get('nest_spend'));
      jar = isFinite(demoJar) && demoJar >= 0 ? Math.min(demoJar, 10000000) : cfg.examplePoints;
      earned = isFinite(demoEarned) && demoEarned >= 0 ? demoEarned : cfg.exampleSpend;
    }
    if (browse) { jar = 0; earned = 0; }

    var tiers = cfg.tiers;
    var tierIdx = 0;
    // Signed in, the level is Appstle's own (it decides the earn rate; points added by hand don't count for it).
    // Previews and signed-out visitors work it out from the points.
    var real = cfg.loggedIn && !demo;
    if (real) {
      tiers.forEach(function (t, i) { if (cfg.vipTier && t.name.toLowerCase() === String(cfg.vipTier).toLowerCase()) tierIdx = i; });
    } else {
      tiers.forEach(function (t, i) { if (earned >= t.at) tierIdx = i; });
    }
    var tier = tiers[tierIdx];
    function publish() {
      // Shared with Build Your Box on this page. rate/points kept for older code; same numbers in jar terms.
      window.GTRewards = {
        rate: browse ? tiers[0].rate : tier.rate, points: browse ? null : jar,
        centsPerDollar: browse ? tiers[0].rate : tier.rate, jarCents: browse ? null : jar,
        tier: browse ? null : tier.name, loggedIn: cfg.loggedIn, preview: demo,
      };
      document.dispatchEvent(new CustomEvent('gtrewards:ready', { detail: window.GTRewards }));
    }
    publish();

    // ---------- the jar ----------
    var jarEl = $('[data-jar]');
    var pourTimer;
    function pour() {   // a bigger slosh: when the jar fills, and when someone taps or hovers it
      if (reduced) return;
      jarEl.classList.remove('is-pour'); void jarEl.offsetWidth; jarEl.classList.add('is-pour');
      clearTimeout(pourTimer);
      pourTimer = setTimeout(function () { jarEl.classList.remove('is-pour'); }, 1800);
    }
    jarEl.addEventListener('click', pour);
    jarEl.addEventListener('mouseenter', pour);
    function showJar() {
      $('[data-bal]').textContent = $m(jar);
      // Never quite to the brim, so the sloshing surface always shows (85% = a full jar).
      var fill = Math.max(jar > 0 ? 0.08 : 0, Math.min(1, jar / (cfg.jarFull || 5000)) * 0.85);
      if (reduced) jarEl.style.setProperty('--jar', fill);
      else setTimeout(function () { jarEl.style.setProperty('--jar', fill); pour(); }, 60);   // a timer, not rAF: rAF waits while the tab is hidden
      jarEl.classList.toggle('is-full', jar >= (cfg.jarFull || 5000));
      $('[data-bal-sub]').textContent = jar > 0
        ? 'Takes up to ' + $m(jar) + ' off an order of ' + $m(Math.max(minCents, Math.ceil(jar / share))) + ' or more'
        : 'Every order adds to it';
    }
    showJar();
    $('[data-tier-chip]').textContent = tier.name + ' · ' + tier.rate + '% back';
    $('[data-hi]').textContent = cfg.loggedIn ? (cfg.firstName ? 'Hi ' + cfg.firstName + ', your jar has' : 'Your jar has') : 'Example member';
    if (demo) {
      $('[data-example]').hidden = false;
      $('[data-wallet]').hidden = false;
      $('[data-signin]').hidden = true;   // the referral card still asks to sign in: a link is only ever a real member's own
    }
    var up = tiers[tierIdx + 1];
    $('[data-tier-next]').textContent = up
      ? (browse
        ? 'Earn ' + pts(up.at) + ' points to reach ' + up.name + ' (' + up.rate + '% back).'
        : earned >= up.at
          ? 'You\'ve earned ' + pts(earned) + ' points. ' + up.name + ' (' + up.rate + '% back) unlocks with your next order.'
          : 'You\'ve earned ' + pts(earned) + ' points. Earn ' + pts(up.at - earned) + ' more to reach ' + up.name + ' (' + up.rate + '% back).')
      : 'You get our top rate: ' + tier.rate + '% back.';
    var card = root.querySelector('[data-tier-card="' + (browse ? 1 : tierIdx + 1) + '"]');
    if (card) {
      card.classList.add('is-you');
      var you = card.querySelector('[data-you]');
      you.hidden = false;
      if (browse) you.textContent = 'Everyone starts here';
    }

    // ---------- app calls (through the store's app proxy, same site) ----------
    function app(action, body) {
      return fetch(proxy + '?action=' + encodeURIComponent(action), {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {}),
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok || !j.ok) throw new Error(j.error || 'Something went wrong. Please try again.');
          return j;
        });
      });
    }

    // ---------- spend: money off the cart ----------
    var sp = {
      cart: $('[data-s-cart]'), jar: $('[data-s-jar]'), max: $('[data-s-max]'), why: $('[data-s-why]'),
      sub: $('[data-s-sub]'), subLabel: $('[data-s-sub-label]'),
      amtWrap: $('[data-s-amtwrap]'), amt: $('[data-s-amt]'), go: $('[data-s-go]'), shop: $('[data-s-shop]'),
      done: $('[data-s-done]'), msg: $('[data-s-msg]'), preview: $('[data-s-preview]'),
    };
    var cart = null;
    var busy = false;
    var edited = false;   // the customer typed their own amount; keep it unless it's now too much
    function isJarCode(code) { return /^GTJAR-/i.test(String(code || '')); }
    // cart.js names a code's order deal by its title (= the code); its key is an internal id (tested Oct 16).
    function isJarDeal(d) { return isJarCode(d.title) || isJarCode(d.key); }
    // The cart's products after product deals and automatic order deals (cart.js: items_subtotal_price is after
    // line deals). Another discount CODE doesn't count: the jar code replaces it, since codes can't be combined.
    function cartValue(c) {
      var v = c.items_subtotal_price || 0;
      (c.cart_level_discount_applications || []).forEach(function (d) {
        if (!isJarDeal(d) && d.type === 'automatic') v -= d.total_allocated_amount || 0;
      });
      return Math.max(0, v);
    }
    function otherCode(c) {
      var hit = (c.discount_codes || []).filter(function (d) { return !isJarCode(d.code) && d.applicable; })[0];
      return hit ? hit.code : '';
    }
    // The jar code on this cart, in cents. A jar code is limited to one customer, and the cart preview can't check
    // that, so cart.js lists it as applicable: false with no amount even though checkout takes it off (live test Oct 19:
    // GTJAR-… $20 showed "not applicable" in the cart and came off at checkout). So the page remembers what each code it
    // made is worth and counts it while the cart still meets that code's minimum (2x the amount, at least the order minimum).
    var JAR_MEMO = 'gtr-jar-code';
    function memo(set) {
      try {
        if (set) { localStorage.setItem(JAR_MEMO, JSON.stringify(set)); return set; }
        return JSON.parse(localStorage.getItem(JAR_MEMO) || 'null');
      } catch (e) { return set || null; }
    }
    function appliedJar(c) {
      var code = (c.discount_codes || []).filter(function (d) { return isJarCode(d.code); })[0];
      if (!code) return 0;
      var hit = (c.cart_level_discount_applications || []).filter(isJarDeal)[0];
      if (hit && hit.total_allocated_amount) return hit.total_allocated_amount;
      var m = memo();
      if (!m || String(m.code).toUpperCase() !== String(code.code).toUpperCase()) return 0;
      return cartValue(c) >= Math.max(minCents, Math.ceil(m.cents / share)) ? m.cents : 0;
    }
    function maxFor(c) { return c ? Math.min(jar, Math.floor(cartValue(c) * share)) : 0; }
    function say(text, bad) { sp.msg.textContent = text || ''; sp.msg.classList.toggle('is-bad', !!bad); }

    function renderSpend() {
      sp.shop.hidden = true;
      sp.amtWrap.hidden = true;
      sp.go.hidden = false;
      sp.jar.textContent = browse ? '—' : $m(jar);
      // The bottom line: the cart after the jar money comes off (before shipping and tax).
      var showSub = function (cents, label) { sp.sub.textContent = cents === null ? '…' : $m(cents); sp.subLabel.textContent = label || 'Your subtotal'; };
      if (browse) {
        sp.cart.textContent = cart ? $m(cartValue(cart)) : '—';
        sp.max.textContent = '—';
        showSub(cart ? cartValue(cart) : null);
        sp.why.textContent = 'Sign in to see your jar and use it on this cart.';
        sp.go.disabled = false;
        sp.go.textContent = 'Sign in';
        return;
      }
      if (!cart) { sp.cart.textContent = '…'; sp.max.textContent = '…'; showSub(null); sp.go.disabled = true; return; }
      var value = cartValue(cart), most = maxFor(cart), onCart = appliedJar(cart);
      sp.cart.textContent = $m(value);
      showSub(onCart ? value - onCart : value, onCart ? 'Subtotal with your jar' : 'Your subtotal');
      sp.max.textContent = value >= minCents ? $m(most) : $m(0);
      sp.done.hidden = !onCart;
      if (onCart) {
        sp.why.textContent = 'Your jar is on this cart: ' + $m(onCart) + ' comes off at checkout. Change your cart? Tap again to resize it.';
      }
      if (jar <= 0) {
        if (!onCart) sp.why.textContent = 'Your jar is empty for now. Every order fills it.';
        sp.go.disabled = true;
        sp.go.textContent = 'Use my jar';
        return;
      }
      if (value < minCents) {
        if (!onCart) sp.why.textContent = value > 0
          ? 'Your jar works on orders of ' + $w(minCents) + ' or more. Add ' + $m(minCents - value) + ' more to use it.'
          : 'Your cart is empty. Add a product above, then use your jar right here.';
        sp.go.hidden = true;
        sp.shop.hidden = false;
        return;
      }
      if (!onCart) {
        var other = otherCode(cart);
        sp.why.textContent = (most < jar
          ? 'Up to half of your ' + $m(value) + ' cart. The rest stays in your jar for next time.'
          : 'Your whole jar fits on this cart.')
          + (other ? ' Using it replaces the code ' + other + ' on your cart, since codes can\'t be combined.' : '');
      }
      sp.amtWrap.hidden = false;
      var typed = Math.round(Number(sp.amt.value) * 100);
      if (!edited || typed > most) { sp.amt.value = (most / 100).toFixed(2); edited = false; }
      sp.amt.max = (most / 100).toFixed(2);
      var want = Math.round(Number(sp.amt.value) * 100);
      var use = want > 0 ? Math.min(want, most) : most;
      if (!onCart) showSub(value - use, 'Subtotal after your jar');
      sp.go.disabled = busy;
      sp.go.textContent = busy ? 'Adding it to your cart…' : 'Use ' + $m(use) + ' on my cart';
    }
    function loadCart() {
      return fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; renderSpend(); return c; })
        .catch(function () { sp.why.textContent = 'We couldn\'t read your cart. Refresh the page to try again.'; });
    }
    sp.amt.addEventListener('input', function () {
      edited = true;
      if (sp.amt.value !== '') renderSpend();   // let them clear the box and retype
      else { sp.go.textContent = 'Use my jar'; if (cart) { sp.sub.textContent = $m(cartValue(cart)); sp.subLabel.textContent = 'Your subtotal'; } }
    });
    sp.amt.addEventListener('blur', function () { if (sp.amt.value === '') { edited = false; renderSpend(); } });
    window.addEventListener('focus', function () { if (!busy) loadCart(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && !busy) loadCart(); });

    sp.go.addEventListener('click', function () {
      if (busy) return;
      if (browse) { window.location.href = cfg.loginUrl; return; }
      busy = true;
      say('');
      renderSpend();
      loadCart().then(function (c) {
        if (!c) throw new Error('We couldn\'t read your cart. Please try again.');
        var value = cartValue(c), most = maxFor(c);
        var want = Math.round(Number(sp.amt.value) * 100);
        if (!(want > 0)) throw new Error('Pick an amount to use.');
        if (value < minCents) throw new Error('Your jar works on orders of ' + $w(minCents) + ' or more.');
        if (want > most) { sp.amt.value = (most / 100).toFixed(2); throw new Error('The most you can use on this cart is ' + $m(most) + ', half of your order.'); }
        if (!live) {
          sp.preview.hidden = false;
          say('Here\'s how it works: ' + $m(want) + ' would come off your ' + $m(value) + ' cart at checkout, and you\'d pay ' + $m(value - want) + ' plus shipping.');
          return;
        }
        return app('jar-redeem', { cents: want, cartCents: value }).then(function (j) {
          // No code (e.g. the app is still in its dry run): nothing changes in the cart.
          if (!j.code) throw new Error('Spending your jar isn\'t switched on yet. Nothing changed.');
          memo({ code: j.code, cents: j.cents || want });
          return fetch(shopRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: j.code }) })
            .then(function (res) {
              if (!res.ok) { window.location.href = shopRoot + 'discount/' + encodeURIComponent(j.code) + '?redirect=' + encodeURIComponent(shopRoot + 'cart'); return null; }
              return loadCart();
            })
            .then(function (c2) {
              if (!c2) return;
              if (appliedJar(c2) > 0) say(j.cents ? $m(j.cents) + ' from your jar comes off at checkout.' : 'Your jar is on your cart.');
              else say('Your code ' + j.code + ' is ready, but your cart changed. Tap Use my jar again.', true);
            });
        });
      })
        .catch(function (err) { say(err.message, true); })
        .finally(function () { busy = false; renderSpend(); });
    });
    renderSpend();
    loadCart();

    // ---------- the core 4: add to the cart without leaving the page ----------
    var coreMsg = $('[data-core-msg]');
    var spendCard = $('[data-spend]');
    // What a card's buttons add: the picked size ("id:qty" in data-size), and on Coop Refresher the picked scent, whose
    // variant (data-variant) replaces the size's id and whose bag price (data-price) × qty is the price.
    function corePick(card) {
      var size = card.querySelector('[data-core-size] [aria-checked="true"]');
      if (!size) return null;
      var s = size.getAttribute('data-size').split(':');
      var out = { id: Number(s[0]), qty: Math.max(1, Number(s[1]) || 1), label: size.getAttribute('data-label'), price: Number(size.getAttribute('data-price')), was: Number(size.getAttribute('data-was') || 0) };
      var scent = card.querySelector('[data-core-scent] [aria-checked="true"]');
      if (scent) {
        out.id = Number(scent.getAttribute('data-variant'));
        out.price = Number(scent.getAttribute('data-price')) * out.qty;
        out.label += ' · ' + scent.getAttribute('data-label');
      }
      return out;
    }
    function corePrice(card) {
      var priceEl = card.querySelector('[data-core-price]');
      var p = corePick(card);
      if (!priceEl || !p) return;
      priceEl.innerHTML = '';
      priceEl.appendChild(document.createTextNode(p.label + ' · '));
      if (p.was) { var st = document.createElement('s'); st.textContent = $m(p.was); priceEl.appendChild(st); priceEl.appendChild(document.createTextNode(' ')); }
      var b = document.createElement('b'); b.textContent = $m(p.price); priceEl.appendChild(b);
    }
    // Size buttons (1 / 2 / 3 / 4) and scent buttons: one is picked per group; the price line follows (cents).
    root.querySelectorAll('[data-core-size], [data-core-scent]').forEach(function (group) {
      var card = group.closest('.gtr-core');
      var pills = [].slice.call(group.querySelectorAll('button[role="radio"]'));
      function pick(pill) {
        pills.forEach(function (p) { p.setAttribute('aria-checked', p === pill ? 'true' : 'false'); p.tabIndex = p === pill ? 0 : -1; });
        corePrice(card);
      }
      pills.forEach(function (pill, n) {
        pill.addEventListener('click', function () { pick(pill); });
        pill.addEventListener('keydown', function (e) {   // arrow keys move between sizes, as in any radio group
          var step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!step) return;
          e.preventDefault();
          var next = pills[(n + step + pills.length) % pills.length];
          pick(next); next.focus();
        });
      });
      if (pills.length) pick(pills[0]);
    });
    root.querySelectorAll('[data-core-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        var id = Number(btn.getAttribute('data-core-add'));
        var qty = 1;
        var name = btn.getAttribute('data-core-name');
        var chosen = corePick(btn.closest('.gtr-core'));
        if (chosen) {
          id = chosen.id; qty = chosen.qty;
          name += ' (' + chosen.label.replace(' · ', ', ') + ')';
        }
        var label = btn.textContent;
        // gt-cart stays shut for an add whose focused element is a "quiet" button, so keep this one focused (Safari
        // doesn't focus buttons on click) and busy rather than disabled (a disabled button drops focus).
        btn.focus({ preventScroll: true });
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';
        fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
          .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'We couldn\'t add that. Please try again.'); }); })
          .then(function () { return loadCart(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = label; }, 1800);
            var value = cart ? cartValue(cart) : 0;
            coreMsg.classList.remove('is-bad');
            coreMsg.innerHTML = '';
            coreMsg.appendChild(document.createTextNode(name + ' is in your cart (' + $m(value) + '). '));
            var go = document.createElement('a');
            go.href = '#' + spendCard.id;
            go.textContent = value >= minCents ? 'Now use your jar ↓' : 'Add ' + $m(minCents - value) + ' more to use your jar';
            if (value < minCents) go.removeAttribute('href');
            coreMsg.appendChild(go);
          })
          .catch(function (err) { coreMsg.classList.add('is-bad'); coreMsg.textContent = err.message; btn.textContent = label; })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    });

    // ---------- links to another spot on this page glide there instead of jumping ----------
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var url = new URL(a.getAttribute('href'), location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + url.hash);
    });

    // ---------- referral link ----------
    var linkEl = $('[data-ref-link]');
    function copyLink(btn) {
      var done = function () { btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = 'Copy'; }, 1800); };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(linkEl.value).then(done, function () { linkEl.select(); document.execCommand('copy'); done(); });
      } else { linkEl.select(); document.execCommand('copy'); done(); }
    }
    if (linkEl) {
      $('[data-copy]').addEventListener('click', function (e) { copyLink(e.currentTarget); });
      linkEl.addEventListener('focus', function () { linkEl.select(); });
      var shareBtn = $('[data-share]');
      if (navigator.share) {
        shareBtn.addEventListener('click', function () {
          navigator.share({ title: cfg.shareSubject, text: cfg.shareText, url: linkEl.value }).catch(function () {});
        });
      } else {
        shareBtn.hidden = true;   // no share sheet here (most desktops); Copy, Text and Email cover it
        shareBtn.parentNode.classList.add('is-two');
      }
    }

    // ---------- put it on your phone ----------
    var head = document.head;
    if (cfg.icon && !head.querySelector('link[rel="apple-touch-icon"]')) {
      var ic = document.createElement('link'); ic.rel = 'apple-touch-icon'; ic.href = cfg.icon; head.appendChild(ic);
    }
    if (!head.querySelector('meta[name="apple-mobile-web-app-title"]')) {
      var mt = document.createElement('meta'); mt.name = 'apple-mobile-web-app-title'; mt.content = cfg.appTitle; head.appendChild(mt);
    }
    var installEvt = null;
    window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); installEvt = e; });
    var appDlg = $('[data-app-dlg]');
    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/i.test(ua);
    function appSteps() {
      var steps = isIOS
        ? ['Tap the Share button (the square with an arrow) at the bottom of Safari.', 'Scroll down and tap <b>Add to Home Screen</b>.', 'Tap <b>Add</b>. The GrubTerra Rewards icon opens your savings jar.']
        : isAndroid
          ? ['Tap the <b>⋮</b> menu at the top right of Chrome.', 'Tap <b>Add to Home screen</b> (or <b>Install app</b>).', 'Tap <b>Add</b>. The GrubTerra Rewards icon opens your savings jar.']
          : ['Open this page on your phone: <b>' + location.host + location.pathname + '</b>', 'On iPhone: Share, then <b>Add to Home Screen</b>.', 'On Android: the <b>⋮</b> menu, then <b>Add to Home screen</b>.'];
      $('[data-app-steps]').innerHTML = steps.map(function (t) { return '<li>' + t + '</li>'; }).join('');
      $('[data-app-install]').hidden = !installEvt;
    }
    var appLast = null;
    function closeApp() { appDlg.hidden = true; document.documentElement.classList.remove('gtr-lock'); if (appLast) appLast.focus(); }
    root.querySelectorAll('[data-app]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        appLast = e.currentTarget; appSteps();
        appDlg.hidden = false; document.documentElement.classList.add('gtr-lock');
        $('[data-app-close]').focus();
      });
    });
    $('[data-app-close]').addEventListener('click', closeApp);
    appDlg.addEventListener('click', function (e) { if (e.target === appDlg) closeApp(); });
    $('[data-app-install]').addEventListener('click', function () {
      if (!installEvt) return;
      installEvt.prompt();
      installEvt.userChoice.finally(function () { installEvt = null; closeApp(); });
    });
    document.addEventListener('keydown', function (e) {
      if (appDlg.hidden) return;
      if (e.key === 'Escape') { closeApp(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(appDlg.querySelectorAll('button:not([hidden]), a[href]:not([hidden]), [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
  }

  function boot() { document.querySelectorAll('.gtr').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
